<div class="flex flex-row pb-3 justify-between pr-2 relative items-center">
    <h2 mat-dialog-title class="dialog-heading capitalize">{{this.heading}}</h2>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._matDialogRef.close()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 overflow-y-auto">
    <div class="flex gap-2 mb-1" *ngIf="this._data.isForCountries;else forState">
        <ng-container *ngFor="let country of countries">
            <div matRipple
                class="flex-1 cursor-pointer flex justify-center pt-5 px-5 text-center flex-col border border-light-gray rounded"
                [ngClass]="{'!border-blue-theme-color' : country.selected ? true : false}" (click)="onSelect(country)">
                <img [src]="country.hdLogo" class="w-full aspect-video object-cover">
                <span
                    class="md:text-lg sm:text-base text-base text-blue-theme-color font-semibold">{{country.title}}</span>
                <div class="min-h-8">
                    <mat-icon class="text-blue-theme-color" *ngIf="country.selected">check_circle</mat-icon>
                </div>
            </div>
        </ng-container>
    </div>
    <ng-template #forState>
        <div class="flex flex-col gap-2 mb-1">
            <ng-container *ngFor="let item of this.listData">
                <div matRipple
                    class="cursor-pointer flex-1 relative bg-[#f5f7ff] py-2 border rounded-sm px-2 border-[#f5f7ff]"
                    (click)="onSelectItem(item)"
                    [ngClass]="{'!border-blue-theme-color' : item.isSelected ? true : false}">
                    <span
                        class="text-blue-theme-color md:text-lg sm:text-base text-base pr-3 font-semibold">{{item.name}}</span>
                    <mat-icon class="text-blue-theme-color absolute right-2 top-[50%] translate-y-[-50%]"
                        *ngIf="item.isSelected">check_circle</mat-icon>
                </div>
            </ng-container>
        </div>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions class="m-0 !pb-5 !px-5 flex justify-center">
    <button color="primary" [disabled]="isCountrySelected()"
        (click)="this._matDialogRef.close(this._data.isForCountries ? this.selectedCountry : this.selectedItem)"
        class="!bg-blue-theme-color !px-6 !h-11 text-white-color" mat-flat-button>
        <span class="btn-text capitalize">{{btn}}</span>
    </button>
</mat-dialog-actions>